// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__MUiUt","card":"Items_card__325Le","loader":"Items_loader__2wfYt"};